// WeeklyThemeDaysList — os sete dias da semana temática (contrato v1.1, Parte 2).
// Consome /api/weekly-theme/{slug}/days via backend. Cada dia traz os blocos
// pastorais INLINE (não aninhados em pastoral_blocks) + scripture_connections.
// Dia atual vem aberto; demais colapsados. Silêncio elegante em falha/vazio.
import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { api } from "../lib/api";
import { PastoralBlocks } from "./PastoralBlocks";
import { ScriptureConnections } from "./ScriptureConnections";

const todayRecifeWeekday = () => {
  const now = new Date(Date.now() - 3 * 3600 * 1000);
  return now.getUTCDay(); // 0=domingo
};

export const WeeklyThemeDaysList = ({ slug }) => {
  const [days, setDays] = useState(null);
  useEffect(() => {
    if (!slug) return;
    let alive = true;
    api
      .get(`/weekly-theme/${slug}/days`)
      .then((r) => {
        const list = r.data?.days;
        if (alive && Array.isArray(list) && list.length) setDays(list);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [slug]);
  if (!days) return null;
  const todayIdx = todayRecifeWeekday();
  return (
    <section className="mt-10" data-testid="semana-seven-days">
      <div className="flex items-center gap-3 mb-4">
        <span className="text-[10px] uppercase tracking-[0.3em] text-gold">Os sete dias da semana</span>
        <span className="flex-1 h-px bg-border" />
      </div>
      <div className="space-y-3">
        {days.map((day) => {
          const idx = Number(day.day_index);
          const isToday = idx === todayIdx;
          return (
            <details
              key={idx}
              open={isToday}
              data-testid={`semana-day-${idx}`}
              className={`rounded-2xl border bg-white ${isToday ? "border-gold/60" : "border-border"}`}
            >
              <summary
                className="list-none cursor-pointer select-none flex items-center justify-between gap-3 p-4 sm:p-5"
                data-testid={`semana-day-summary-${idx}`}
              >
                <span className="min-w-0">
                  <span className="flex items-center gap-2">
                    <span className="text-[10px] uppercase tracking-[0.25em] text-navy/55">
                      {day.weekday}
                    </span>
                    {isToday && (
                      <span className="text-[10px] uppercase tracking-widest bg-gold/15 text-navy/75 px-2 py-0.5 rounded-full">
                        Hoje
                      </span>
                    )}
                  </span>
                  {day.abertura && (
                    <span className="mt-1 block font-display text-base sm:text-lg text-navy leading-snug line-clamp-2">
                      {day.abertura}
                    </span>
                  )}
                </span>
                <ChevronDown className="w-4 h-4 text-navy/40 shrink-0" aria-hidden="true" />
              </summary>
              <div className="px-4 sm:px-5 pb-5 pt-1 border-t border-border/60">
                <PastoralBlocks blocks={day} testidPrefix={`semana-day-${idx}-block`} />
                {Array.isArray(day.scripture_connections) && day.scripture_connections.length > 0 && (
                  <div className="mt-6">
                    <p className="text-[10px] uppercase tracking-[0.3em] text-navy/55 mb-3">Conexões bíblicas</p>
                    <ScriptureConnections
                      connections={day.scripture_connections}
                      testidPrefix={`semana-day-${idx}-connection`}
                    />
                  </div>
                )}
              </div>
            </details>
          );
        })}
      </div>
    </section>
  );
};
